<div class="toggle_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"
*ngIf="isToggle"
>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>

<div class="select_all" *ngIf="gridView">
    <div
    class="detail_entered"
      *ngFor="let adrProgress of adrProgresss"
      (click)="onView(adrProgress)"
    >
    <div class="picture"></div>
      <div class="the_details" (click)="onView(adrProgress)">
        <h2 class="name">{{ getYearOfSuit(adrProgress.YearOfSuitId).YearOfSuitName }}</h2>
        <div class="other_detail">
          <!-- <h5>
            <span class="label">Year of Suit</span>
            <span class="Answer">{{ getYearOfSuit(adrProgress.YearOfSuitId).YearOfSuitName }}</span>
          </h5> -->
          <h5>
            <span class="label">Party</span>
            <span class="Answer"
              >{{ adrProgress.PartyA }}</span
            >
          </h5>
          <h5>
            <span class="label">VS</span>
            <span class="Answer"
              >{{ adrProgress.PartyB }}</span
            >
          </h5>
        </div>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="listView">
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Year of Suit</th>
          <th scope="col">Party</th>
          <th scope="col">VS</th>
        </tr>
      </thead>
      <tbody >
        <tr *ngFor="let adrProgress of adrProgresss; index as i"
        (click)="onView(adrProgress)"
        style="cursor: pointer;"
        >
          <th scope="row">{{i + 1}}</th>
          <td>{{ getYearOfSuit(adrProgress.YearOfSuitId).YearOfSuitName }}</td>
          <td>{{ adrProgress.PartyB }}</td>
          <td>{{ adrProgress.PartyB }}</td>
        </tr>
  
      </tbody>
    </table>
  
  </div>
  
  